import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Calendar, MapPin } from 'lucide-react';

/**
 * Lightweight set of links to other customer surfaces. Lives at the
 * bottom of the account page — nothing here is account-management,
 * just shortcuts so customers don't have to navigate back to the
 * navbar.
 */
export default function QuickLinksSection() {
  const { t } = useTranslation();
  return (
    <section className="rounded-xl border border-neutral-200 bg-white p-5 shadow-sm">
      <h2 className="mb-3 text-sm font-semibold uppercase tracking-wider text-neutral-500">
        {t('account.quick_links')}
      </h2>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <QuickLink to="/bookings" icon={<Calendar className="h-4 w-4" />} label={t('account.my_bookings')} />
        <QuickLink to="/venues" icon={<MapPin className="h-4 w-4" />} label={t('account.find_venue')} />
      </div>
    </section>
  );
}

function QuickLink({
  to,
  icon,
  label,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
}) {
  return (
    <Link
      to={to}
      className="flex items-center justify-between rounded-md border border-neutral-200 px-3 py-2 text-sm text-neutral-700 transition-colors hover:border-[#C2713A] hover:text-[#C2713A]"
    >
      <span className="flex items-center gap-2">
        {icon}
        {label}
      </span>
      <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </Link>
  );
}
